import { Outlet, useNavigate } from 'react-router-dom';
import { MOBILE_FOOTER_HEIGHT } from '../../ui/dashboard/DashboardLayout';
import { DashboardPage } from '../../ui/dashboard/DashboardPage';
import { Box } from '../../ui/layout/Box';
import { Typography } from '../../ui/typography/Typography';
import { useIsAdvertisingCatalogEnabled } from '../../utils/useIsAdvertisingCatalogEnabled';
import { useTranslation } from '../../utils/useTranslation';

export const AdvertisingCatalog: React.FC<{}> = () => {
    const navigate = useNavigate();
    const t = useTranslation();

    const isAdvertisingCatalogEnabled = useIsAdvertisingCatalogEnabled();

    if (!isAdvertisingCatalogEnabled) {
        navigate('/');
    }

    return (
        <DashboardPage
            pb={0}
            pr={{ sm: 3 }}
            maxWidth="100%"
            centered={false}
            height={{ xs: `calc(100dvh - ${MOBILE_FOOTER_HEIGHT}px)`, sm: '100vh' }}
        >
            <Typography variant="title2" weight="heavy" p={2} display={{ xs: 'none', sm: 'block' }}>
                {t('Монетизация')}
            </Typography>
            <Box
                width="100%"
                height="100%"
                overflow="hidden"
                backgroundColor={{ sm: 'var(--background-primary)' }}
                borderRadius={{ sm: 2 }}
                px={2}
                mb={{ sm: 1 }}
            >
                <Outlet />
            </Box>
        </DashboardPage>
    );
};
